const global = window;

// Ouverture générique d'un popup basé sur un élément ou une config
global.openElementPopup = function (element, popupConfig, event) {
    const $el = $(element);
    let popup = popupConfig || $el.data('popup');
    if (typeof popup === 'string') {
        try {
            popup = JSON.parse(popup);
        } catch (e) {
            popup = null;
        }
    }
    if (!popup) return false;

    if ($el.is(':disabled') || $el.hasClass('btn--disabled') || $el.attr('disabled') || $el.data('hold')) {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        return false;
    }

    const pf = $el.closest('.window, body');
    const formData = (typeof getFormData === 'function') ? getFormData(pf) : {};

    let url = popup.url || '';
    if (!url && popup.form && Array.isArray(popup.form)) {
        url = 'app/modules/' + popup.form[0] + '/forms/' + popup.form[1] + '.php?incOpp=form&incModule=' + popup.form[0] + '&incForm=' + popup.form[1];
    }

    // Seules les données explicitement passées dans popup.data sont envoyées (aucune rétrocompatibilité avec les champs hors data)
    let data = popup.data && typeof popup.data === 'object' ? JSON.parse(JSON.stringify(popup.data)) : {};

    // Si popup contient un id (module.form ou id de vue/fenêtre)
    if (popup.id && data.id === undefined) {
        data.id = popup.id;
    }

    // Récupération de la valeur d'un champ dynamique
    const getFieldValue = function (fieldName) {
        let val = formData[fieldName];
        if (val === undefined || val === null || val === '') {
            let field = pf.find('[data-name="' + fieldName + '"], [data-id="' + fieldName + '"], [name="' + fieldName + '"], #' + fieldName);
            if (!field.length) {
                field = $('[data-name="' + fieldName + '"], [data-id="' + fieldName + '"], [name="' + fieldName + '"], #' + fieldName);
            }
            if (field.length) {
                val = field.val();
                if (val === undefined || val === null || val === '') {
                    val = field.data('value') !== undefined ? field.data('value') : field.attr('data-value');
                }
            }
        }
        if (val === undefined || val === null || val === '') {
            if (typeof URLSearchParams !== 'undefined' && window.location && window.location.search) {
                const urlParams = new URLSearchParams(window.location.search);
                if (urlParams.has(fieldName)) {
                    val = urlParams.get(fieldName);
                }
            }
        }
        if (val === undefined || val === null || val === '') {
            const $param = $('#param');
            if ($param.length && $param.val()) {
                const paramStr = $param.val().replace(/^[&?]/, '');
                const pParams = new URLSearchParams(paramStr);
                if (pParams.has(fieldName)) {
                    val = pParams.get(fieldName);
                }
            }
        }
        if (val === undefined || val === null || val === '') {
            if (window[fieldName] !== undefined && typeof window[fieldName] !== 'function' && typeof window[fieldName] !== 'object') {
                val = window[fieldName];
            } else if (window.c && window.c[fieldName] !== undefined) {
                val = window.c[fieldName];
            }
        }
        return val !== undefined && val !== null ? val : '';
    };

    // Remplacement des templates {{field}}
    const resolvePlaceholders = function (value) {
        if (typeof value === 'string') {
            if (value.indexOf('{{') > -1 || value.indexOf('%7B%7B') > -1) {
                value = value.replace(/%7B%7B([A-Za-z0-9_-]+)%7D%7D/g, '{{$1}}');
                const exactMatch = value.match(/^\{\{([A-Za-z0-9_-]+)\}\}$/);
                if (exactMatch) {
                    return getFieldValue(exactMatch[1]);
                }
                return value.replace(/\{\{([A-Za-z0-9_-]+)\}\}/g, function (match, fieldName) {
                    return getFieldValue(fieldName);
                });
            }
            return value;
        } else if (Array.isArray(value)) {
            return value.map(resolvePlaceholders);
        } else if (value !== null && typeof value === 'object') {
            const result = {};
            Object.keys(value).forEach(function (k) {
                result[k] = resolvePlaceholders(value[k]);
            });
            return result;
        }
        return value;
    };

    // Remplacement des variables dans l'URL: {{field}}
    if (url && (url.indexOf('{{') > -1 || url.indexOf('%7B%7B') > -1)) {
        url = url.replace(/%7B%7B([A-Za-z0-9_-]+)%7D%7D/g, '{{$1}}');
        url = url.replace(/\{\{([A-Za-z0-9_-]+)\}\}/g, function (match, fieldName) {
            return encodeURIComponent(getFieldValue(fieldName));
        });
    }

    // Remplacement dynamique des variables dans popup.data
    data = resolvePlaceholders(data);

    // Mémoriser la config popup dans data-data de l'élément pour inputReloadParent
    $el.data('data', Object.assign($el.data('data') || {}, { popup: popup }));

    const rawTitle = popup.title || $el.attr('title') || $el.data('title') || 'Fenêtre';
    const title = resolvePlaceholders(rawTitle);
    const width = popup.width ? popup.width : 950;
    const height = popup.height ? popup.height : 750;
    const icon = popup.icon || null;

    ajaxPopup(
        title,
        width,
        height,
        url,
        data,
        (popupInstance) => {
            if (typeof inputReloadParent === 'function') {
                inputReloadParent(element, popupInstance);
            }
        },
        icon,
        event
    );

    if (event) {
        event.preventDefault();
        event.stopPropagation();
    }
    return false;
};

// Remplissage automatique et comportement popup pour les champs enregistrés
inputs.behavior.popup = function (data, name, niceName, type, input, parent, inputWindow) {
    if (data.popup) {
        input.data('registered-popup', true);
        input.off('click.inputPopup').on('click.inputPopup', function (event) {
            global.openElementPopup(this, data.popup, event);
        });
    }
    return data;
};

// Déclenchement générique délégué pour tout élément avec [data-popup]
$(document).on('click', '[data-popup]', function (event) {
    if ($(this).data('registered-popup')) {
        return;
    }
    const onclickAttr = $(this).attr('onclick');
    if (onclickAttr && !onclickAttr.includes('return false') && !onclickAttr.includes('stopPropagation')) {
        return;
    }
    global.openElementPopup(this, null, event);
});
